var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course"},[_c('div',{staticClass:"course__thumb"},[_c('CourseThumb',{attrs:{"course":_vm.course}}),_c('RoundIcon',{staticClass:"pos-bottom-center icon--relative"},[_c('BadgeSVG')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }